import { useCallback } from 'react';
import { setBannerDisplayFlag } from '../lib';

export const useClose = () => {
	const onClose = useCallback(() => {
		setBannerDisplayFlag(true);
	}, []);
	return onClose;
};
